// @ts-check

const meansNone = [
  'n',
  'no',
  'non',
  'none',
  'nkda',
  'no known',
  'no',
  'n/a',
  'nka',
]

const getNoneFunction = (...otherStrings) => {
  const stringsThatMeanNone = [...meansNone, ...otherStrings].map(s =>
    s.toLowerCase()
  )
  return str => {
    if (!str) return false
    const cleaned = str.trim().toLowerCase()
    return stringsThatMeanNone.includes(cleaned)
  }
}

export const stringMeansNone = getNoneFunction()

const isAnesNone = getNoneFunction('No known anesthesia complications')

/** @type {Partial<{ [key in HhxField]: (val: string) => boolean }>} */
export const noneStringTestsByField = {
  allergiesSummary: stringMeansNone,
  healthHistoryNotes: stringMeansNone,
  lungAuscultation: getNoneFunction('CTAB'),
  heartAuscultation: getNoneFunction('RRR w/o murmur', 'RRR'),
  hospitalizationSummary: stringMeansNone,
  surgicalHistorySummary: stringMeansNone,
  anesthesiaHistorySummary: isAnesNone,
  familyAnesthesiaHistorySummary: isAnesNone,
}

/**
 * @param {HhxField} fieldName
 * @param {any} value
 * @returns {boolean | null}
 */
export const caseFieldStringMeansNone = (fieldName, value) => {
  const test = noneStringTestsByField[fieldName]
  if (test) {
    return test(value)
  }
  return null
}
